const filterStations = function filterStationsBasedOnKeyFromPageUrl(
  key,
  pageType,
  stations,
  genre
) {
  if (key.toLowerCase() === 'all') return stations;
  if (genre)
    return stations.filter(station => station.genres.includes(genre.id));
  return [];
};

export default filterStations;
